export const UPDATE_WELCOME_LOGIN_MODAL = 'UPDATE_WELCOME_LOGIN_MODAL';
export const CLEAR_CSRF = "CLEAR_CSRF";

// GenAI Content Constants
export const FETCH_GENAI_CONTENT_REQUEST = 'FETCH_GENAI_CONTENT_REQUEST';
export const FETCH_GENAI_CONTENT_SUCCESS = 'FETCH_GENAI_CONTENT_SUCCESS';
export const FETCH_GENAI_CONTENT_FAILURE = 'FETCH_GENAI_CONTENT_FAILURE';

// Blackbelt Content Constants
export const FETCH_BLACKBELT_CONTENT_REQUEST = 'FETCH_BLACKBELT_CONTENT_REQUEST';
export const FETCH_BLACKBELT_CONTENT_SUCCESS = 'FETCH_BLACKBELT_CONTENT_SUCCESS';
export const FETCH_BLACKBELT_CONTENT_FAILURE = 'FETCH_BLACKBELT_CONTENT_FAILURE';

// AgenticAI Content Constants
export const FETCH_AGENTICAI_CONTENT_REQUEST = 'FETCH_AGENTICAI_CONTENT_REQUEST';
export const FETCH_AGENTICAI_CONTENT_SUCCESS = 'FETCH_AGENTICAI_CONTENT_SUCCESS';
export const FETCH_AGENTICAI_CONTENT_FAILURE = 'FETCH_AGENTICAI_CONTENT_FAILURE';